import React from 'react';
import PropTypes from 'prop-types';
import './PermissionLoading.scss';
import { useTheme } from '@mui/material/styles';
import { AppBar, Box, Toolbar, CircularProgress } from '@mui/material';
import Header from './Header';
import useAuthExternalUser from '../../hooks/useAuthExternalUser';
import useAuth from '../../hooks/useAuth';
import { USER_TYPE } from '../../constants';
// ==============================|| MAIN LAYOUT ||============================== //
const PermissionLoading = ({ userPermissionsNotFound }) => {
  const { externalUserLogout, getUserType } = useAuthExternalUser();
  const userType = getUserType();
  const { logout } = useAuth();
  const isExtranalUser = userType === USER_TYPE.externalUser;
  const handleLogout = async () => {
    if (isExtranalUser) {
      externalUserLogout();
    } else {
      logout();
    }
  };
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar
        enableColorOnDark
        position="fixed"
        color="inherit"
        elevation={0}
        sx={{
          bgcolor: theme.palette.background.default,
        }}
      >
        <Toolbar>
          <Header />
        </Toolbar>
      </AppBar>
      <Box className="acmLoader">
        {userPermissionsNotFound === true ? (
          <div
            className="auth-loader-container"
            style={{ textAlign: 'center' }}
          >
            <p>User permissions are not found.</p>
              <button className="refreshBtn" onClick={() => handleLogout()}>
                Re-Login
              </button>
          </div>
        ) : (
          <div
            className="auth-loader-container"
            style={{ textAlign: 'center' }}
          >
            <CircularProgress
              className="auth-loader"
              style={{ color: '#55b848' }}
            />
            <br />
            <p>User permissions are loading...</p>
          </div>
        )}
      </Box>
    </Box>
  );
};
PermissionLoading.propTypes = {
  userPermissionsNotFound: PropTypes.any,
};

export default PermissionLoading;
